window.HHTabsCarouselSync = window.HHTabsCarouselSync || {
  _handlers: {},

  register: function (config) {
    var sectionId = String(config.sectionId);

    if (this._handlers[sectionId]) {
      window.removeEventListener('hh:tabs-carousel:select', this._handlers[sectionId]);
      delete this._handlers[sectionId];
    }

    if (!config.syncEnabled) {
      return function noop() {};
    }

    var handler = function (e) {
      if (!e.detail) return;
      if (String(e.detail.sourceSectionId) === sectionId) return;
      var tabKey = e.detail.tabKey;
      if (!tabKey) return;
      if (!config.root || !config.root.isConnected) return;

      var tag = config.root.querySelector('[data-hh-tab-key="' + CSS.escape(tabKey) + '"]');
      if (!tag) return;

      var targetId = tag.getAttribute('data-target');
      if (targetId) config.setActive(targetId);
    };

    this._handlers[sectionId] = handler;
    window.addEventListener('hh:tabs-carousel:select', handler);

    return function emitFromTag(tag) {
      var tabKey = tag.getAttribute('data-hh-tab-key');
      if (!tabKey) return;
      window.dispatchEvent(
        new CustomEvent('hh:tabs-carousel:select', {
          detail: { tabKey: tabKey, sourceSectionId: sectionId },
        })
      );
    };
  },
};
